import './assets/scss/index.scss'

import * as React from 'react'
import { useState, useEffect } from 'react'
import Routes from './routes'

import { useGetUserMutation } from '../src/redux/api/userApi'
import { useAuthTokenMutation } from './redux/api/authApi'

const App: React.FC = () => {
  const [loaded, setLoaded] = useState<boolean>(false)
  const [getUser] = useGetUserMutation()
  const [getToken] = useAuthTokenMutation()

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    getToken().then(() => {
    }).catch(() => {})
    getUser().then(() => {
      setLoaded(true)
    }).catch(() => {})
  }, [])
  return (
    <React.Fragment>
      {loaded && (
        <Routes />
      )}
    </React.Fragment>
  )
}

export default App
